<div
  class="bg-white rounded-2xl shadow-md flex flex-col shrink-0 transition-all duration-200 overflow-hidden"
  [class.w-14]="!expanded"
  [class.w-72]="expanded"
>
  <div class="flex items-center gap-2 px-2 py-3 border-b border-gray-100" [class.justify-center]="!expanded">
    <button
      type="button"
      class="w-9 h-9 shrink-0 inline-flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
      [disabled]="disabled"
      [title]="expanded ? 'Recolher empresas' : 'Buscar empresa'"
      (click)="toggleExpanded()"
    >
      <lucide-icon
        [name]="expanded ? 'chevrons-left' : 'chevrons-right'"
        [size]="18"
        class="text-chathams-blue"
      ></lucide-icon>
    </button>

    <div class="form-group mb-0 flex-1" *ngIf="expanded">
      <input
        class="form-input h-9 text-sm"
        placeholder="Buscar empresa"
        [(ngModel)]="searchTerm"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <div class="flex flex-col overflow-y-auto max-h-[70vh]">
    <button
      type="button"
      *ngFor="let company of filteredCompanies"
      class="flex items-center gap-2 px-2 py-2 border-l-4 hover:bg-iceberg transition-colors text-left"
      [class.justify-center]="!expanded"
      [style.border-color]="company.id === selectedCompanyId ? 'var(--search-filter-background)' : 'transparent'"
      [class.bg-iceberg]="company.id === selectedCompanyId"
      [disabled]="disabled"
      [title]="company.name"
      (click)="selectCompany(company)"
    >
      <img
        *ngIf="company.logo; else initialsAvatar"
        [src]="company.logo"
        [alt]="company.name"
        class="w-8 h-8 shrink-0 rounded-full object-cover"
        (error)="company.logo = ''"
      />
      <ng-template #initialsAvatar>
        <span
          class="w-8 h-8 shrink-0 rounded-full bg-chathams-blue text-white text-xs font-bold inline-flex items-center justify-center"
        >
          {{ getInitials(company) }}
        </span>
      </ng-template>

      <span *ngIf="expanded" class="text-sm text-chathams-blue truncate">{{ company.name }}</span>
    </button>

    <p *ngIf="expanded && !filteredCompanies.length" class="text-xs text-gray-400 px-2 py-2">
      Nenhuma empresa encontrada.
    </p>
  </div>
</div>
